import { roundToFormat } from "@Shared/Helpers/Numbers";
export const format = (amount, points = 2) => {
    if (amount === undefined) {
        return;
    }
    const formatted = roundToFormat(amount, points);
    return `£${formatted}`;
};
